import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import {  studentFetchStudentMissions, } from '../../services2/studentMissions.service';
import StudentReport from '../admin/components/StudentReport.js';
import { fetchSchoolMissions } from '../../services2/schoolMissions.service.js';

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [mission, setmission] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const [schoolMission, setschoolMission] = useState(null)

     const fetchMission = async () => {
            let result = await studentFetchStudentMissions(props.token.token, { _id: id });
            if (result.result) {
                setmission(result.result?.[0] || null)
                fetchSchoolMission(result.result?.[0]?.missionId)
            } else {
                alert('Fetch data error')
            }
        }
    
        const fetchSchoolMission = async (missionId) => {
             let result = await fetchSchoolMissions(props.token.token,{missionId},{limit:1});
            if (result.result) {
                setschoolMission(result.result?.[0] || null)
            } else {
                console.log('Fetch data error')
            }
        }

    const refresh = async () => {
        if (isLoading) return
        setisLoading(true)
        await fetchMission()
        setisLoading(false)
    }

    useEffect(() => {
        refresh()
    }, [id])


    if(schoolMission?.disableAnswer){
        return (
            <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflowY: "auto" }}>
                <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap pl-[16px] pt-[16px] mb-[8px]'>
                    <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate(`/platform2/records`) }}>{`<`} 返回</div>
                </div>
                <div className='flex-1 flex justify-center items-center'>
                    <div className='text-[#1D1D41] text-[24px] font-[400]'>無法查看成績單</div>
                </div>
            </div>
        )
    }


    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflow: "auto" }}>
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap pl-[16px] pt-[16px] mb-[8px]'>
                <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate(`/platform2/records`) }}>{`<`} 返回</div>
            </div>
            <StudentReport mission={mission}/>
        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
